import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Menu, X } from "lucide-react";

const links = [
  { label: "Kenapa Gemini Pro", href: "#kenapa" },
  { label: "Fitur", href: "#fitur" },
  { label: "Perbandingan", href: "#perbandingan" },
  { label: "Cara Kerja", href: "#cara-kerja" },
  { label: "Testimoni", href: "#testimoni" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const goTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-[3px] left-0 right-0 z-50 bg-white/75 backdrop-blur-xl border-b border-slate-200/60"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <a href="#" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-heading font-extrabold text-lg tracking-tight text-slate-900">
            Hotaro<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">Digital</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" data-testid="navbar-menu">
          {links.map((link) => (
            <button
              key={link.href}
              onClick={() => goTo(link.href)}
              data-testid={`navbar-link-${link.href.slice(1)}`}
              className="text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => setOpen(!open)}
          data-testid="navbar-menu-toggle"
          className="lg:hidden w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-slate-700"
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-t border-slate-200/60"
            data-testid="navbar-mobile-menu"
          >
            <div className="px-5 py-4 flex flex-col gap-1">
              {links.map((link) => (
                <button
                  key={link.href}
                  onClick={() => goTo(link.href)}
                  data-testid={`navbar-mobile-link-${link.href.slice(1)}`}
                  className="text-left text-base font-semibold text-slate-700 hover:text-blue-600 py-2.5 transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
